module.exports = __webpack_public_path__ + "static/banner-furnisima-slider-d1e900072cfa975dd507e482f46ae9a0.png";